import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import cn from 'classnames'
import styles from './style.module.css'
import localStyles from './Preloader.module.css'
import PageHeader from '~components/PageLayout/PageHeader'
import PageLayout from '~components/PageLayout'

function Preloader() {
    return (
        <PageLayout
            contentWidth="m"
            header={
                <PageHeader
                    rootPage
                    title={
                        <div className={localStyles.wrap}>
                            <Loader width={160} height={20} />
                        </div>
                    }
                />
            }
        >
            <div className={cn(styles.wrap, localStyles.preloaderWrap)} data-pointer="transfer_page_preloader" />
        </PageLayout>
    )
}

export default Preloader
